import JavaLogo from "../../assets/images/java-logo.png";
import PhpLogo from "../../assets/images/php-logo.png";
import NodeLogo from "../../assets/images/node-js-logo-small.png";
import PythonLogo from "../../assets/images/python_1.png";
import HTMLLogo from "../../assets/images/html.png";
import CSSLogo from "../../assets/images/css.png";
import JavaScriptLogo from "../../assets/images/javascript-logo.png";
import ReactLogo from "../../assets/images/react-js-logo.png";
import AngularLogo from "../../assets/images/angular-logo.png";
import VueLogo from "../../assets/images/vuejs-logo.png";
import NextLogo from "../../assets/images/nextjs.png";
import AndroidLogo from "../../assets/images/android-logo.png";
import IOSLogo from "../../assets/images/ios-logo.png";
import ProgressiveWebAppLogo from "../../assets/images/pwa-logo.png";
import PostgreSQLLogo from "../../assets/images/postgresql-vertical-logo.png";
import MySQLLogo from "../../assets/images/mysql.png";
import OracleLogo from "../../assets/images/oracle.png";
import MongoDBLogo from "../../assets/images/mongodb-logo.png";
import AWSLogo from "../../assets/images/aws.png";
import GoogleCloudLogo from "../../assets/images/google-cloud-logo.png";
import DigitalOceanLogo from "../../assets/images/digital-ocean.png";
import AmazonS3Logo from "../../assets/images/amazon-s3.png";
import AmazonDynamoLogo from "../../assets/images/amazon-dynamodb-logo.png";
import AmazonDocumentDBLogo from "../../assets/images/amazon-documentdb.png";
import AmazonRDSLogo from "../../assets/images/amazon-rds-logo.png";
import AWSElasticacheLogo from "../../assets/images/aws-elasticache.png";
import DockerLogo from "../../assets/images/docker-logo.png";
import KubernetesLogo from "../../assets/images/kubernetes-logo.png";
import AwsESCLogo from "../../assets/images/AwsEcs.png";
import AwsDeveloperToolsLogo from "../../assets/images/aws-developer-tools.png";
import GoogleDeveloperToolsLogo from "../../assets/images/google-developer-tools.png";
import JenkinsLogo from "../../assets/images/jenkins.png";
import PrometheusLogo from "../../assets/images/prometheus-logo.png";
import GrafanaLogo from "../../assets/images/grafana-logo.png";
import ElasticSearchLogo from "../../assets/images/elasticsearch.png";
import SeleniumLogo from "../../assets/images/selenium.png";
import PostmanLogo from "../../assets/images/postman.png";
import ApacheJmeterLogo from "../../assets/images/apache-jmeter.png";
import FlutterLogo from "../../assets/images/flutter-logo.png";

export const technologiesData = {
  Cloud: [
    { id: 1, name: "AWS", image: AWSLogo },
    { id: 2, name: "Google Cloud", image: GoogleCloudLogo },
    { id: 3, name: "Digital Ocean", image: DigitalOceanLogo },
  ],
  CloudDatabases: [
    { id: 1, name: "Amazon S3", image: AmazonS3Logo },
    { id: 2, name: "Amazon DynamoDB", image: AmazonDynamoLogo },
    { id: 3, name: "Amazon DocumentDB", image: AmazonDocumentDBLogo },
    { id: 4, name: "Amazon RDS", image: AmazonRDSLogo },
    { id: 5, name: "AWS Elasticache", image: AWSElasticacheLogo },
  ],
  DevOpsContainerization: [
    { id: 1, name: "Docker", image: DockerLogo },
    { id: 2, name: "Kubernetes", image: KubernetesLogo },
    { id: 3, name: "AWS ECS", image: AwsESCLogo },
  ],
  DevOpsCICDTools: [
    { id: 1, name: "AWS Developer Tools", image: AwsDeveloperToolsLogo },
    { id: 2, name: "Google Developer Tools", image: GoogleDeveloperToolsLogo },
    { id: 3, name: "Jenkins", image: JenkinsLogo },
  ],
  DevOpsMonitoring: [
    { id: 1, name: "Prometheus", image: PrometheusLogo },
    { id: 2, name: "Grafana", image: GrafanaLogo },
    { id: 3, name: "Elastic Search", image: ElasticSearchLogo },
  ],
  TestingAutomationTools: [
    { id: 1, name: "Selenium", image: SeleniumLogo },
    { id: 2, name: "Postman", image: PostmanLogo },
    { id: 3, name: "Apache Jmeter", image: ApacheJmeterLogo },
  ],
  Backend: [
    { id: 1, name: "Node.js", image: NodeLogo },
    { id: 2, name: "Python", image: PythonLogo },
    { id: 3, name: "Java", image: JavaLogo },
    { id: 4, name: "PHP", image: PhpLogo },
  ],
  Frontend: [
    { id: 1, name: "HTML", image: HTMLLogo },
    { id: 2, name: "CSS", image: CSSLogo },
    { id: 3, name: "JavaScript", image: JavaScriptLogo },
  ],
  Framework: [
    { id: 1, name: "React", image: ReactLogo },
    { id: 2, name: "Angular", image: AngularLogo },
    { id: 3, name: "Vue.js", image: VueLogo },
    { id: 4, name: "Next.js", image: NextLogo },
  ],
  Mobile: [
    { id: 1, name: "Android", image: AndroidLogo },
    { id: 2, name: "iOS", image: IOSLogo },
    { id: 3, name: "Progressive Web App", image: ProgressiveWebAppLogo },
    { id: 4, name: "Flutter", image: FlutterLogo },
  ],
  Database: [
    { id: 1, name: "PostgreSQL", image: PostgreSQLLogo },
    { id: 2, name: "MySQL", image: MySQLLogo },
    { id: 3, name: "Oracle", image: OracleLogo },
    { id: 4, name: "MongoDB", image: MongoDBLogo },
  ],
};